import { useState, useEffect } from 'react';

export const MediaQueries = {
  xs: 'only screen and (max-width: 375px)',
  sm: 'only screen and (max-width: 576px)',
  md: 'only screen and (max-width: 767px)',
  lg: 'only screen and (max-width: 1200px)',
  xl: 'only screen and (max-width: 1381px)',
  // Below additional sizes
  tablet: 'only screen and (max-width: 768px)',
  compensationSearchGridMdSize: 'only screen and (max-width: 810px)',
  tabletLandscape: 'only screen and (max-width: 1024px)',
  extraLgSize: 'only screen and (max-width: 1199px)',
  ipadPro: 'only screen and (max-width: 1283px)',
};

const useDeviceResize = (query) => {
  const queryToMatch = MediaQueries[query] || MediaQueries.lg;
  const [matches, setMatches] = useState(window.matchMedia(queryToMatch).matches);

  useEffect(() => {
    const media = window.matchMedia(queryToMatch);

    if (media.matches !== matches) setMatches(media.matches);

    const listener = () => setMatches(media.matches);

    if (media.addEventListener) {
      media.addEventListener('change', listener);
    } else media.addEventListener(listener);

    return () => (media.removeEventListener
      ? media.removeEventListener('change', listener)
      : media.removeEventListener(listener));
  }, [matches, queryToMatch]);

  return matches;
};

export default useDeviceResize;
